<script>
import HasParentTargetMixin from './HasParentTargetMixin.vue'

export default {
  mixins: [HasParentTargetMixin],
  props: {
    customClass: {
      type: String,
      required: false,
      default: 'popover_tooltip',
    },
    placement: {
      type: String,
      required: false,
      default: 'bottom',
    },
  },
}
</script>

<template>
  <b-popover
    :placement="placement"
    triggers="hover"
    :target="getTarget"
    :custom-class="customClass"
  >
    <slot />
  </b-popover>
</template>

<style lang="scss">
.popover.b-popover.popover_tooltip .popover-body {
  max-height: 75vh;
  overflow-y: auto;
}
</style>
